import { FC } from 'react';
import { HiXMark } from 'react-icons/hi2';
import { IHiddenIssuesMessage } from './hiddenIssuesMessage';

interface IHiddenIssuesChipProps {
    message: IHiddenIssuesMessage;
    /** Число строк для схлопнутого вида в тесном туллбаре. */
    count?: number;
    onReveal?: () => void;
    onDismiss: () => void;
}

/**
 * Сигнал «в скрытых столбцах есть незаполненные обязательные ячейки» —
 * в туллбаре между наборами колонок и выбором столбцов.
 *
 * Полосой над гридом он быть не может: её появление добавляет строку и вся
 * таблица уезжает вниз. Здесь сообщение живёт в уже существующем ряду, поэтому
 * раскладка не двигается ни при появлении, ни при уходе (раскладка — в
 * `.tdn-issues` в TableData.scss, там же условия сжатия).
 */
const HiddenIssuesChip: FC<IHiddenIssuesChipProps> = ({ message, count, onReveal, onDismiss }) => (
    <div
        className={`tdn-issues tdn-issues--${message.tone}`}
        role={message.tone === 'danger' ? 'alert' : 'status'}
        title={`${message.headline}. ${message.detail}`}
    >
        <span className="tdn-issues__dot" aria-hidden />
        {count !== undefined && <span className="tdn-issues__count">{count}</span>}
        <span className="tdn-issues__text">
            <b>{message.headline}</b>
        </span>
        {onReveal && (
            <button type="button" className="tdn-issues__act" onClick={onReveal}>
                Показать
            </button>
        )}
        <button type="button" className="tdn-issues__close" onClick={onDismiss} aria-label="Скрыть подсказку">
            <HiXMark aria-hidden />
        </button>
    </div>
);

export default HiddenIssuesChip;
